export default __webpack_public_path__ + "static/media/galeria-drivr2.b64d4c55.JPG";